import { render, staticRenderFns } from "./SecaoDiferencial.vue?vue&type=template&id=5b04d222&scoped=true"
import script from "./SecaoDiferencial.vue?vue&type=script&lang=js"
export * from "./SecaoDiferencial.vue?vue&type=script&lang=js"
import style0 from "./SecaoDiferencial.vue?vue&type=style&index=0&id=5b04d222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04d222",
  null
  
)

export default component.exports